import type { IconSvgObject } from './types';

const FileBoxIcon: IconSvgObject = [
  ["path", { d: "M4.5 9.99976V3.99976C4.5 2.89519 5.39543 1.99976 6.5 1.99976H13.5L20.5 8.99976V19.9998C20.5 21.1043 19.6046 21.9998 18.5 21.9998H14.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M13.5 1.99976V6.99976C13.5 8.10433 14.3954 8.99976 15.5 8.99976H20.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M12.5 14.4998L8 11.9998L3.5 14.4998L8 16.9998L12.5 14.4998Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M12.5 14.4998V19.5001L8 22.0002L3.5 19.5001V14.4998M8 16.9998V21.5024", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default FileBoxIcon;
